import { performRequestTypeGET, performRequestTypePOST } from "../utils/servicesUtils";

export const getAccessScopeService = async () =>
  performRequestTypeGET("/api/dashboard/access-scope/", { errorMessage: "Failed to load access scope" });

export const searchGlobalService = async (payload, { signal } = {}) =>
  performRequestTypePOST("/api/dashboard/search/", {
    body: payload || {},
    signal,
    errorMessage: "Failed to search",
  });
